import { Component } from '@angular/core';

@Component({
  selector: 'app-subscribe-thank-you',
  templateUrl: './subscribe-thank-you.component.html',
  styleUrls: ['./subscribe-thank-you.component.scss']
})
export class SubscribeThankYouComponent {

}
